module.exports = __webpack_public_path__ + "img/cover.322150b4.png";